import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth-context'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

export function QuickActionsModal() {
  const { auth, showQuickActions, dismissQuickActions } = useAuth()
  const navigate = useNavigate()

  return (
    <Dialog open={showQuickActions} onOpenChange={(open) => !open && dismissQuickActions()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>¡Bienvenida, {auth?.user.name}!</DialogTitle>
          <DialogDescription>¿Qué quieres hacer primero?</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={dismissQuickActions}>
            Continuar al panel
          </Button>
          <Button
            onClick={() => {
              dismissQuickActions()
              navigate('/admin/ventas/nueva')
            }}
          >
            Nueva venta
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
